/* edited by Mary: AV PDP desktop arrows delegate to the theme's native thumbnail controls. */
(() => {
  if (window.__avPdpGalleryArrowsInitialized) return;
  window.__avPdpGalleryArrowsInitialized = true;

  const navigationSelector = '[data-av-pdp-gallery-navigation]';
  const thumbnailSelector = '[data-product-thumbnail]';
  const observedGalleries = new WeakSet();
  let updateQueued = false;

  const getGallery = navigation =>
    navigation.closest('.product__media-container.above-mobile[data-gallery-style="thumbnails"]');

  const getThumbnails = navigation => {
    const gallery = getGallery(navigation);
    return gallery ? Array.from(gallery.querySelectorAll(thumbnailSelector)) : [];
  };

  const updateNavigation = navigation => {
    const thumbnails = getThumbnails(navigation);
    const activeIndex = thumbnails.findIndex(thumbnail => thumbnail.classList.contains('active'));
    const previousButton = navigation.querySelector('[data-av-pdp-gallery-previous]');
    const nextButton = navigation.querySelector('[data-av-pdp-gallery-next]');
    const hasActiveThumbnail = activeIndex >= 0;

    if (previousButton) previousButton.disabled = !hasActiveThumbnail || activeIndex === 0;
    if (nextButton) nextButton.disabled = !hasActiveThumbnail || activeIndex === thumbnails.length - 1;

    const gallery = getGallery(navigation);
    const mediaArea = gallery && gallery.querySelector('.product__media');
    if (mediaArea) {
      navigation.style.setProperty('--av-pdp-gallery-navigation-height', `${mediaArea.offsetHeight}px`);
    }
  };

  const updateAllNavigation = () => {
    document.querySelectorAll(navigationSelector).forEach(updateNavigation);
  };

  const observeGallery = navigation => {
    const gallery = getGallery(navigation);
    if (!gallery || observedGalleries.has(gallery)) return;

    observedGalleries.add(gallery);
    new MutationObserver(mutations => {
      if (mutations.some(mutation => mutation.attributeName === 'class')) queueUpdate();
    }).observe(gallery, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  };

  const initializeNavigation = () => {
    document.querySelectorAll(navigationSelector).forEach(navigation => {
      observeGallery(navigation);
      updateNavigation(navigation);
    });
  };

  const queueUpdate = () => {
    if (updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(() => {
      updateQueued = false;
      updateAllNavigation();
    });
  };

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-av-pdp-gallery-previous], [data-av-pdp-gallery-next]');
    if (!button || button.disabled) return;

    const navigation = button.closest(navigationSelector);
    const thumbnails = getThumbnails(navigation);
    const activeIndex = thumbnails.findIndex(thumbnail => thumbnail.classList.contains('active'));
    const direction = button.hasAttribute('data-av-pdp-gallery-next') ? 1 : -1;
    const targetThumbnail = thumbnails[activeIndex + direction];

    if (targetThumbnail) targetThumbnail.click();
    queueUpdate();
  });

  window.addEventListener('resize', queueUpdate, { passive: true });
  document.addEventListener('product:variant-change', queueUpdate);

  /* edited by Mary: watch only DOM replacements so Shopify variant refreshes receive controls. */
  const observer = new MutationObserver(mutations => {
    if (mutations.some(mutation => mutation.addedNodes.length)) initializeNavigation();
  });

  const start = () => {
    initializeNavigation();
    observer.observe(document.body, {
      subtree: true,
      childList: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
